var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('BaseTemp',{scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('PrivacyPolicy')]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }